import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RequiredFieldMark } from "common/fields/RequiredFieldMark";
import { IconWithTooltip, IconWithTooltipVariant } from "common/tooltip";

export interface IFieldLabelProps {
  label?: string | JSX.Element;
  children: React.ReactNode;
  labelId?: string;
  color?: string;
  required?: boolean;
  toolTipTitle?: string;
  tooltipIconVariant?: IconWithTooltipVariant;
  totalHeightForLabelAndField?: number;
  disabled?: boolean;
}

export const FieldLabel: React.FC<IFieldLabelProps> = ({
  children,
  label,
  labelId,
  color,
  required,
  toolTipTitle,
  tooltipIconVariant = "info",
  totalHeightForLabelAndField,
  disabled,
}) => {
  const { t: translate } = useTranslation("common");
  return (
    <Box sx={{ mb: 2, height: totalHeightForLabelAndField }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          id={labelId}
          component="label"
          variant="subtitle2"
          color={disabled ? "action.disabled" : color ? color : undefined}
        >
          {label}
          {required && <RequiredFieldMark disabled={disabled} />}
        </Typography>
        {toolTipTitle && (
          <IconWithTooltip
            tooltipText={toolTipTitle}
            placement="right-start"
            aria-label={translate("components.tooltips.tooltip_information")}
            variant={tooltipIconVariant}
            iconSx={{ ml: 1 }}
          />
        )}
      </Box>
      <Box sx={{ mt: 0.5 }}>{children}</Box>
    </Box>
  );
};
